export default "__VITE_ASSET__CqEeHPbx__"